import { useCallback, useEffect, useRef, useState } from "react";
import update from "immutability-helper";
import { RejectProcess } from "const";

const initCrs = {
  fetching: false,
  crs: null,
  countryOfTaxList: [],
};

function useCRS(options) {
  const [crsInfo, setCrsInfo] = useState(initCrs);
  const optionRef = useRef();

  useEffect(() => {
    optionRef.current = options;
  }, [options]);

  const verifyCRS = useCallback(async (manualPayload) => {
    setCrsInfo((state) =>
      update(state, {
        fetching: {
          $set: true,
        },
      })
    );

    const api = optionRef.current.api;
    const payload =
      optionRef.current.payload || manualPayload
        ? { ...(optionRef.current.payload || {}), ...(manualPayload || {}) }
        : undefined;
    const response = await api(payload);
    const crsInfo = response.data?.result ?? response.data ?? {};

    if (crsInfo.crs) {
      let resolve, reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });

      setCrsInfo({
        ...crsInfo,
        fetching: false,
        callback: { resolve, reject },
      });

      return promise;
    }
  }, []);

  const resolveCRS = useCallback(() => {
    if (crsInfo.callback?.resolve) {
      crsInfo.callback.resolve();
    }

    setCrsInfo(initCrs);
  }, [crsInfo]);

  const resetCRS = useCallback(() => {
    if (crsInfo.callback?.reject) {
      crsInfo.callback.reject(new Error(RejectProcess));
    }

    setCrsInfo(initCrs);
  }, [crsInfo.callback]);

  const isRejectError = useCallback((error) => {
    return !!error?.message?.includes(RejectProcess);
  }, []);

  return [crsInfo, { verifyCRS, resolveCRS, resetCRS, isRejectError }];
}

export default useCRS;
